import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { QuestionMetricsPayload } from "@/domain/model/question_metrics";

import { addNewQuestionMetric } from "./services/addNewQuestionMetric";

export const useAddNewQuestionMetric = () => {
  const { messageCode } = useParams<{ messageCode?: string }>();

  const mutation = useMutation({
    mutationFn: async (data: QuestionMetricsPayload) =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      await addNewQuestionMetric(messageCode || "", data),
  });

  const addNewQuestionMetricReq = async (data: QuestionMetricsPayload) =>
    mutation.mutateAsync(data);

  return { addNewQuestionMetric: addNewQuestionMetricReq, ...mutation };
};
